// External Imports
import get from 'lodash/fp/get';
import { createSelector } from 'reselect';

// Internal Imports
import { TERM_ARCHIVE } from '../config/types/path.js';
import { tagToLearnLanguage } from '../utils/tagToLearnLanguage.js';
import { getMatch } from './getMatch.js';
import { getEdition } from './getEdition.js';

// Local Functions
const getLearnLanguage = createSelector([getMatch, getEdition], (match, edition) => {
  const {
    pathType,
    params: { slug },
  } = match ?? { params: {} };

  if (pathType !== TERM_ARCHIVE) {
    return get('query.learn_language', match);
  }

  return tagToLearnLanguage(edition, slug);
});

// Module Exports
export { getLearnLanguage };
